import React, { useEffect } from "react";

const GoogleTranslateDropdown = () => {
  useEffect(() => {
    // Define the callback BEFORE script is loaded
    window.googleTranslateElementInit = () => {
      if (window.google && window.google.translate) {
        new window.google.translate.TranslateElement(
          {
            pageLanguage: "en",
            layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
          },
          "google_translate_element"
        );
      }
    };

    // Load the Google Translate script
    const script = document.createElement("script");
    script.src =
      "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    script.async = true;
    document.body.appendChild(script);

    // Cleanup
    return () => {
      document.body.removeChild(script);
      delete window.googleTranslateElementInit;
    };
  }, []);

  return (
    <div style={{ textAlign: "center", margin: "2px"}}>
      <div id="google_translate_element"></div>
      <p
        style={{
          fontSize: "12px",
          color: "#ffffff",
          background: "#4A2DA0",
          padding: "0px",
          display:"none"
        }}
      >
        Powered by{" "}
        <span style={{ color: "#4285F4" }}>G</span>
        <span style={{ color: "#DB4437" }}>o</span>
        <span style={{ color: "#F4B400" }}>o</span>
        <span style={{ color: "#4285F4" }}>g</span>
        <span style={{ color: "#0F9D58" }}>l</span>
        <span style={{ color: "#DB4437" }}>e</span> Translate
      </p>
    </div>
  );
};

export default GoogleTranslateDropdown;
